export const SCREEN_ASSISTANT_COPY = {
  title: "MagicBI",
  contextPrefix: "Working on",
  collapse: "Close MagicBI",
  region: "MagicBI assistant",
  sectionTitle: "On this screen",
  listLabel: "Actions on this screen",
  empty: "Nothing to run here yet. Ask in your own words below.",
  placeholder: "Ask MagicBI or type an action",
  noMatch: "I couldn't match that to an action on this screen.",
  hint: "Press Enter to send",
} as const;
